import React from "react";
import Header from "../header";
import Popup from "../popup";
import Betslip from "../../components/betslip";
import ProfileHandler from "../../components/userProfileSubscriber";
import Loader from "../../components/loader";
import Config from "../../../../dev/config/main";
import KeyboardForCasino from "../../components/keyboardForCasino/index";
import Helpers from "../../../helpers/helperFunctions";

export default function layoutTemplate () {
    let { location, data } = this.props,
        disabledHeader = location.pathname === "/admin",
        disabledBetslip = location.pathname === "/admin" || location.pathname === "/casino" || location.pathname === "/dealer" || location.pathname === "/casino/Favorites" || location.pathname === "/result",
        enableClassicViewBetslip = location.pathname.indexOf("prematch") > 0 || location.pathname.indexOf("live") > 0 || location.pathname.indexOf("today") > 0;

    const authData = sessionStorage.getItem('authData');

    return (
        this.props.appReady // start rendering only when application is ready (translations/config/etc are loaded)
            ? <>
                {Helpers.isSplitScreenAvailable() && <iframe src={`${Config.splitScreenUrl}/?&pid=${authData.pid}&lng=${authData.lng || Config.env.lang}`} />}
                <div className={`terminal-wrapper ${(!data.isAsian && enableClassicViewBetslip) && "sport-classic-view"}`} onClick={this.handleClick}>
                    {!disabledHeader ? <Header {...this.props}/> : null}
                    <div className="content-wrapper-t" onClick={this.props.uiClose("openLanguages")}>
                        <div className={`scroll-container-t ${location.pathname.includes("thirdPartyGame") && "lottery"} ${Config.terminal.scrollButtons && "scroll-b-view"}`}>
                            {this.props.children}
                            {this.props.user && !this.props.user.loginInProgress && this.props.user.loggedIn ? <ProfileHandler /> : (null)}
                        </div>
                    </div>
                    <Betslip disableBetslip={!disabledBetslip}/>
                    <Popup/>
                    {
                        data.showKeyboard && (() => {
                            return <KeyboardForCasino/>;
                        })()
                    }
                </div>
            </>
            : <Loader/>
    );
}